// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewReadyPlanCostsQueryVariables = Types.Exact<{
  input: Types.ComputeReadyPlanCostsInput;
}>;


export type ReviewReadyPlanCostsQuery = { __typename?: 'Query', computeReadyPlanCosts: { __typename?: 'ComputeReadyPlanCostsResult', readyPlanCosts: Array<{ __typename?: 'ReadyPlanCosts', itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string, displayVersion: string }, computedCosts: Array<{ __typename?: 'ComputeReadyPlanCostResult', totalCostInCents: number, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, deltas: Array<{ __typename?: 'ReadyPlanOptionCostDelta', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string } } }> }> }> } };

export type RpCostsFragment = { __typename?: 'ReadyPlanCosts', itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string, displayVersion: string }, computedCosts: Array<{ __typename?: 'ComputeReadyPlanCostResult', totalCostInCents: number, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, deltas: Array<{ __typename?: 'ReadyPlanOptionCostDelta', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string } } }> }> };

export type ComputedRpCostsFragment = { __typename?: 'ComputeReadyPlanCostResult', totalCostInCents: number, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, deltas: Array<{ __typename?: 'ReadyPlanOptionCostDelta', totalCostInCents: number, readyPlanOption: { __typename?: 'ReadyPlanOption', id: string, location?: { __typename?: 'Location', id: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', id: string } } }> };

export type ReviewReadyPlanCostsFiltersQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type ReviewReadyPlanCostsFiltersQuery = { __typename?: 'Query', readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, displayName: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', order: number, id: string, name: string } } }> }>, itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string, displayVersion: string, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined }> };

export type ReviewReadyPlanCostsRpFragment = { __typename?: 'ReadyPlan', id: string, displayName: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', order: number, id: string, name: string } } }> };

export type ReviewReadyPlanCostsRpoFragment = { __typename?: 'ReadyPlanOption', id: string, code: string, displayName: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, globalOption: { __typename?: 'GlobalOption', code: string, id: string, name: string, type: { __typename?: 'GlobalOptionType', order: number, id: string, name: string } } };

export const ComputedRpCostsFragmentDoc = gql`
    fragment ComputedRpCosts on ComputeReadyPlanCostResult {
  readyPlanOptions {
    id
    displayName
  }
  totalCostInCents
  deltas {
    readyPlanOption {
      id
      location {
        id
      }
      globalOption {
        id
      }
    }
    totalCostInCents
  }
}
    `;
export const RpCostsFragmentDoc = gql`
    fragment RpCosts on ReadyPlanCosts {
  itemTemplate {
    id
    displayName
    displayVersion
  }
  computedCosts {
    ...ComputedRpCosts
  }
}
    ${ComputedRpCostsFragmentDoc}`;
export const ReviewReadyPlanCostsRpoFragmentDoc = gql`
    fragment ReviewReadyPlanCostsRpo on ReadyPlanOption {
  id
  code
  displayName
  location {
    ...Named
  }
  globalOption {
    ...Named
    code
    type {
      ...Named
      order
    }
  }
}
    ${NamedFragmentDoc}`;
export const ReviewReadyPlanCostsRpFragmentDoc = gql`
    fragment ReviewReadyPlanCostsRp on ReadyPlan {
  id
  displayName
  options {
    ...ReviewReadyPlanCostsRpo
  }
}
    ${ReviewReadyPlanCostsRpoFragmentDoc}`;
export const ReviewReadyPlanCostsDocument = gql`
    query ReviewReadyPlanCosts($input: ComputeReadyPlanCostsInput!) {
  computeReadyPlanCosts(input: $input) {
    readyPlanCosts {
      ...RpCosts
    }
  }
}
    ${RpCostsFragmentDoc}`;

/**
 * __useReviewReadyPlanCostsQuery__
 *
 * To run a query within a React component, call `useReviewReadyPlanCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewReadyPlanCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewReadyPlanCostsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewReadyPlanCostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables> & ({ variables: ReviewReadyPlanCostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>(ReviewReadyPlanCostsDocument, options);
      }
export function useReviewReadyPlanCostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>(ReviewReadyPlanCostsDocument, options);
        }
// @ts-ignore
export function useReviewReadyPlanCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>;
export function useReviewReadyPlanCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewReadyPlanCostsQuery | undefined, ReviewReadyPlanCostsQueryVariables>;
export function useReviewReadyPlanCostsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>(ReviewReadyPlanCostsDocument, options);
        }
export type ReviewReadyPlanCostsQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsQuery>;
export type ReviewReadyPlanCostsLazyQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsLazyQuery>;
export type ReviewReadyPlanCostsSuspenseQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsSuspenseQuery>;
export type ReviewReadyPlanCostsQueryResult = Apollo.QueryResult<ReviewReadyPlanCostsQuery, ReviewReadyPlanCostsQueryVariables>;
export const ReviewReadyPlanCostsFiltersDocument = gql`
    query ReviewReadyPlanCostsFilters($developmentId: ID!) {
  readyPlans(filter: {development: [$developmentId]}) {
    ...ReviewReadyPlanCostsRp
  }
  itemTemplates(
    filter: {development: [$developmentId], isReadyHomeTemplate: true, status: [ACTIVE, DRAFT]}
  ) {
    id
    displayName
    displayVersion
    readyPlan {
      id
    }
  }
}
    ${ReviewReadyPlanCostsRpFragmentDoc}`;

/**
 * __useReviewReadyPlanCostsFiltersQuery__
 *
 * To run a query within a React component, call `useReviewReadyPlanCostsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewReadyPlanCostsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewReadyPlanCostsFiltersQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useReviewReadyPlanCostsFiltersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables> & ({ variables: ReviewReadyPlanCostsFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>(ReviewReadyPlanCostsFiltersDocument, options);
      }
export function useReviewReadyPlanCostsFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>(ReviewReadyPlanCostsFiltersDocument, options);
        }
// @ts-ignore
export function useReviewReadyPlanCostsFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>;
export function useReviewReadyPlanCostsFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewReadyPlanCostsFiltersQuery | undefined, ReviewReadyPlanCostsFiltersQueryVariables>;
export function useReviewReadyPlanCostsFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>(ReviewReadyPlanCostsFiltersDocument, options);
        }
export type ReviewReadyPlanCostsFiltersQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsFiltersQuery>;
export type ReviewReadyPlanCostsFiltersLazyQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsFiltersLazyQuery>;
export type ReviewReadyPlanCostsFiltersSuspenseQueryHookResult = ReturnType<typeof useReviewReadyPlanCostsFiltersSuspenseQuery>;
export type ReviewReadyPlanCostsFiltersQueryResult = Apollo.QueryResult<ReviewReadyPlanCostsFiltersQuery, ReviewReadyPlanCostsFiltersQueryVariables>;